import React from "react";
import { Link } from "../../types/link";
import { isNullOrWhiteSpace } from "../utilities/string";
import { Button } from "./buttons/Button";
import { Columns } from "./containers/Columns";
import { Container } from "./containers/Container";
import { DynamicImage, DynamicImageSource } from "./DynamicImage";

export type HeroProductProps = {
  subHeader: string;
  headline: string;
  preamble: string;
  primaryBtn: Link;
  secondaryBtn?: Link;
  imgUrl?: DynamicImageSource;
};

export const HeroProduct: React.FC<HeroProductProps> = ({
  subHeader,
  headline,
  preamble,
  primaryBtn,
  secondaryBtn,
  imgUrl
}) => {
  const imagePullClass = "-mt-xxl desktop:-mt-370 relative";
  const noImageMarginClass = "mt-[5.875rem]";

  return (
    <div className="flex flex-col max-h-fit">
      {!!imgUrl && (
        <DynamicImage
          className="w-full object-cover object-center h-530 tablet:h-592 desktop:h-814"
          src={imgUrl}
          alt=""
        />
      )}
      <Container>
        <Columns
          colSize="full"
          desktopColSize="10/12"
          justify="justify-center"
          justifyDesktop="justify-center"
        >
          <div
            className={`w-full desktop:max-w-780 border border-theme3-500 bg-white p-lg desktop:p-xxl ${
              imgUrl ? imagePullClass : noImageMarginClass
            }`}
          >
            <div className="flex flex-col">
              {!isNullOrWhiteSpace(subHeader) && (
                <div className="font-sans text-stylized text-secondary-300 not-italic uppercase">
                  {subHeader}
                </div>
              )}
              {!isNullOrWhiteSpace(headline) && (
                <h1 className="font-serif text-h1 text-secondary-500 not-italic mb-md">
                  {headline}
                </h1>
              )}

              {!isNullOrWhiteSpace(preamble) && (
                <p className="font-sans text-large text-secondary-500 font-300 not-italic mb-lg tablet:mb-xl desktop:mb-xxl">
                  {preamble}
                </p>
              )}

              <div className="flex flex-col flex-wrap gap-y-sm tablet:flex-row tablet:gap-x-lg">
                {primaryBtn && (
                  <Button
                    theme="secondary"
                    type="link"
                    url={primaryBtn.url}
                    title={primaryBtn.title}
                    variant="large"
                  >
                    {primaryBtn.label}
                  </Button>
                )}

                {secondaryBtn &&
                  !isNullOrWhiteSpace(secondaryBtn.url) &&
                  !isNullOrWhiteSpace(secondaryBtn.label) && (
                    <Button
                      theme="secondary-hollow"
                      type="link"
                      url={secondaryBtn.url}
                      title={secondaryBtn.title}
                      variant="large"
                    >
                      {secondaryBtn.label}
                    </Button>
                  )}
              </div>
            </div>
          </div>
        </Columns>
      </Container>
    </div>
  );
};
